import type { SendFormDataKeys } from './http.types';
import { defaultRequestKeysMap, sendFormDataFieldsMap } from './http.constants';

export function serializeToFormData(params: Record<string, unknown>, wrapFormDataKey = true) {
  return Object.entries(params).reduce((formData, [key, value]) => {
    const mappedKey = sendFormDataFieldsMap[key as SendFormDataKeys] ?? key;
    const fdKey = wrapFormDataKey ? `fields[${mappedKey}]` : mappedKey;
    const fdValue = `${value}`;
    formData.set(fdKey, fdValue);
    return formData;
  }, new FormData());
}

export function serializeToFormDataDefaultRequestKeys<T>(params: T) {
  return Object.entries(params as Record<string, unknown>).reduce((formData, [key, value]) => {
    const mappedKey = defaultRequestKeysMap[key as keyof typeof defaultRequestKeysMap] ?? key;
    const fdValue = `${value}`;
    formData.set(mappedKey, fdValue);
    return formData;
  }, new FormData());
}
